// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
     tab-size: 4;
  /* 3 */
  font-family: Inter, sans-serif;
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

.quoter-absolute {
  position: absolute;
}

.quoter-relative {
  position: relative;
}

.quoter-left-\\[-26px\\] {
  left: -26px;
}

.quoter-left-\\[-40px\\] {
  left: -40px;
}

.quoter-left-\\[16px\\] {
  left: 16px;
}

.quoter-left-\\[46px\\] {
  left: 46px;
}

.quoter-top-4 {
  top: 1rem;
}

.quoter-top-\\[75px\\] {
  top: 75px;
}

.quoter-mb-5 {
  margin-bottom: 1.25rem;
}

.quoter-mb-64 {
  margin-bottom: 16rem;
}

.quoter-mb-7 {
  margin-bottom: 1.75rem;
}

.quoter-mb-\\[10px\\] {
  margin-bottom: 10px;
}

.quoter-ml-0 {
  margin-left: 0px;
}

.quoter-ml-4 {
  margin-left: 1rem;
}

.quoter-ml-\\[10px\\] {
  margin-left: 10px;
}

.quoter-ml-\\[32px\\] {
  margin-left: 32px;
}

.quoter-mt-1 {
  margin-top: 0.25rem;
}

.quoter-mt-2 {
  margin-top: 0.5rem;
}

.quoter-mt-3 {
  margin-top: 0.75rem;
}

.quoter-mt-\\[-3px\\] {
  margin-top: -3px;
}

.quoter-mt-\\[10px\\] {
  margin-top: 10px;
}

.quoter-mt-\\[1px\\] {
  margin-top: 1px;
}

.quoter-mt-\\[4px\\] {
  margin-top: 4px;
}

.quoter-mt-\\[8px\\] {
  margin-top: 8px;
}

.quoter-flex {
  display: flex;
}

.quoter-h-\\[48px\\] {
  height: 48px;
}

.quoter-h-\\[60px\\] {
  height: 60px;
}

.quoter-h-\\[70px\\] {
  height: 70px;
}

.quoter-w-\\[145px\\] {
  width: 145px;
}

.quoter-w-\\[163px\\] {
  width: 163px;
}

.quoter-w-\\[228px\\] {
  width: 228px;
}

.quoter-w-\\[252px\\] {
  width: 252px;
}

.quoter-w-\\[270px\\] {
  width: 270px;
}

.quoter-w-\\[328px\\] {
  width: 328px;
}

.quoter-w-\\[416px\\] {
  width: 416px;
}

.quoter-w-full {
  width: 100%;
}

.quoter-w-\\[380px\\] {
  width: 380px;
}

.quoter-w-\\[136px\\] {
  width: 136px;
}

.quoter-w-\\[258px\\] {
  width: 258px;
}

.quoter-max-w-\\[328px\\] {
  max-width: 328px;
}

.quoter-cursor-pointer {
  cursor: pointer;
}

.quoter-flex-row {
  flex-direction: row;
}

.quoter-flex-col {
  flex-direction: column;
}

.quoter-items-center {
  align-items: center;
}

.quoter-rounded-lg {
  border-radius: 0.5rem;
}

.quoter-rounded-md {
  border-radius: 0.375rem;
}

.quoter-border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.quoter-bg-blue-quoter {
  --tw-bg-opacity: 1;
  background-color: rgb(1 95 199 / var(--tw-bg-opacity));
}

.quoter-p-0 {
  padding: 0px;
}

.quoter-p-\\[10px\\] {
  padding: 10px;
}

.quoter-pr-4 {
  padding-right: 1rem;
}

.quoter-pt-1 {
  padding-top: 0.25rem;
}

.quoter-text-left {
  text-align: left;
}

.quoter-font-sans {
  font-family: Inter, sans-serif;
}

.quoter-text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.quoter-text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.quoter-text-\\[14px\\] {
  font-size: 14px;
}

.quoter-text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.quoter-font-bold {
  font-weight: 700;
}

.quoter-font-normal {
  font-weight: 400;
}

.quoter-font-semibold {
  font-weight: 600;
}

.quoter-capitalize {
  text-transform: capitalize;
}

.quoter-italic {
  font-style: italic;
}

.quoter-text-error {
  --tw-text-opacity: 1;
  color: rgb(214 92 94 / var(--tw-text-opacity));
}

.quoter-text-grey-primary {
  --tw-text-opacity: 1;
  color: rgb(82 97 102 / var(--tw-text-opacity));
}

.quoter-shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 640px) {
  .sm\\:quoter-mr-\\[10px\\] {
    margin-right: 10px;
  }

  .sm\\:quoter-mt-0 {
    margin-top: 0px;
  }

  .sm\\:quoter-flex {
    display: flex;
  }

  .sm\\:quoter-w-\\[228px\\] {
    width: 228px;
  }

  .sm\\:quoter-w-\\[330px\\] {
    width: 330px;
  }

  .sm\\:quoter-max-w-\\[570px\\] {
    max-width: 570px;
  }

  .sm\\:quoter-flex-row {
    flex-direction: row;
  }

  .sm\\:quoter-items-start {
    align-items: flex-start;
  }
}

@media (min-width: 768px) {
  .md\\:quoter-absolute {
    position: absolute;
  }

  .md\\:quoter-relative {
    position: relative;
  }

  .md\\:quoter-top-\\[90px\\] {
    top: 90px;
  }

  .md\\:quoter-w-\\[344px\\] {
    width: 344px;
  }

  .md\\:quoter-max-w-\\[344px\\] {
    max-width: 344px;
  }

  .md\\:quoter-text-center {
    text-align: center;
  }
}

@media (min-width: 1024px) {
  .lg\\:quoter-fixed {
    position: fixed;
  }

  .lg\\:quoter-absolute {
    position: absolute;
  }

  .lg\\:quoter-top-\\[280px\\] {
    top: 280px;
  }

  .lg\\:quoter-top-\\[464px\\] {
    top: 464px;
  }

  .lg\\:quoter-top-\\[90px\\] {
    top: 90px;
  }
}
/* @tailwind base;
@tailwind components; */
@tailwind utilities;

/* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap'); */
/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'); */

/* html,body {
  background: #0463C7!important;
  margin: 2rem auto;
}

.App {
  width: 328px;
  display: flex!important;
  margin: auto!important;
  align-items: center!important;
  justify-content: center!important;
} */

.quoter-bg-overlay {
  background: #000;
  opacity: 0;
  position: absolute;
  z-index: 98;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.quoter-bg-overlay.fade-in { /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
  animation: fadein 1s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.35;
  }
}

/* Firefox < 16 */

/* Safari, Chrome and Opera > 12.1 */

/* Internet Explorer */

/* Opera < 12.1 */
.main-quoter-container {
  /* max-width: 342px; */
  width: 328px;
  position: relative;
  z-index: 100;
}
.main-quoter-container.normal-mode {
  /* background: 
  ; */
  width: 100%;
}
.main-quoter-container.compact-mode {
  /* background: lime; */
  width: 328px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
*/ .MuiBox-root {
  color: #526166;
  font-weight: 600;
}

.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {
  padding-top: 25px;
  padding-bottom: 13px;
}

#quoter-destination
  svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined {
  top: 23px;
  right: 16px;
}

.MuiMenu-paper {
  transition-duration: 0s !important;
}

#quoter-destination .MuiInputBase-root.MuiOutlinedInput-root {
  border-radius: 8px;
}

.quoter-dates-container,
.quoter-pax-ages {
  border-radius: 8px;
  border: 1px solid #bec2c5;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  overflow: hidden;
}

.quoter-dates-block,
.quoter-block {
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
}
.quoter-dates-block .date {
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px; /* 14.4px */
  letter-spacing: 0.48px;
}
.quoter-dates-from-date,
.quoter-dates-to-date,
.quoter-block {
  padding-left: 14px;
}

.quoter-dates-from-date {
  border-right: 1px solid #bec2c5;
}

.quoter-dates-to-date {
}

#quoter-dates {
}

#quoter-dates .label {
  margin-top: -2px;
}
#quoter-dates .data-dates .label {
  margin-top: -2px;
}
#quoter-dates .data-dates .date {
  margin-top: 2px;
}

.quoter-pax-ages button {
  display: flex;
  width: 40px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 9px;
  background: #eff1f4;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1),
    1px -2px 4px 0px rgba(0, 0, 0, 0.1) inset;
  color: #414e58;
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 110% */
}
.ages-selection-container {
  display: flex;
}

.submit-btn {
  border-radius: 8px;
  background: var(--secondary-50-main, #7bd0c2);
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.12);
}

#quoter-dates,
.quoter-block {
  background: white;
}

.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {
  background: white;
}

.MuiInput-input {
  font-size: 45px;
}

li.MuiButtonBase-root.MuiMenuItem-root.MuiMenuItem-gutters.MuiMenuItem-root.MuiMenuItem-gutters.text-grey-primary.css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root {
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
}
/* .MuiTooltip-popper {
  margin-bottom: 0;
  transform: translate3d(262.667px, -468.667px, 0px)!important;
} */

label {
  font-family: Inter, sans-serif;
}

.border-error-field {
  border: 2px solid #d65c5e !important;
}

#quoter-destination fieldset {
  border-color: white;
}

.quote-submit-btn {
  font-family: 'Inter', sans-serif;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quote-submit-btn:disabled {
  opacity: 0.2;
}
#quoter-destination .MuiInputBase-root.MuiOutlinedInput-root {
  border-radius: 8px;
}
.dest_label {
  position: absolute;
  font-family: Inter, sans-serif;
  top: 4px;
  text-align: left;
  width: auto;
  color: #526166;
  /* left: 48px; */
  display: block;
  font-size: 12px;
  z-index: 10;
  text-transform: uppercase;
  font-weight: 700;
}

.tooltip-container {
  position: relative;
  width: 100%;
}

.MuiTooltip-popper[data-popper-placement*='top'] .MuiTooltip-tooltip {
  margin-bottom: 10px !important;
}

.destination-container {
  position: relative;
  /* width: 328px; */
  border-radius: 8px;
  border: 2px solid white;
  background: white;
}

.select_destiny .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {
  padding-top: 22px !important;
}

.calendar {
  margin-top: 4px;
  /* scroll-margin: 16px; */
  scroll-margin-top: 104px;
}

.header {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 6px 6px 0 0;
  background-color: #1abc9c;
  color: #fff;
}

.nav {
  width: 30px;
  height: 30px;
  border: 1px solid #fff;
  border-radius: 99px;
  outline: 0;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
}

.week-container,
.day-container {
  display: flex;
  flex-wrap: wrap;
}

.week-container {
  width: 100%;
  padding: 0 39px;
  display: flex;
}

.week-cell,
.day-cell {
  user-select: none;
  -moz-user-select: none;
  -webkit-text-select: none;
  -webkit-user-select: none;
  flex: 0 0 calc(100% / 7);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  border: 0;
  background-color: transparent;
  color: #002430;
  /* width: 32px;
  height: 32px; */
  /* margin-bottom: 0.75rem; */
  width: 40px;
  height: 40px;
  margin-bottom: 7px;
}

.week-cell {
  text-align: center;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  line-height: 120%;
  text-transform: uppercase;
  color: #95a2a6;
  padding: 0.55rem 0;
  /* padding: 0.55rem; */
}

.day-cell--faded,
.day-cell--disabled {
  pointer-events: none;
  color: #b2b2b9;
}

.day-cell--today {
  background-color: #f5f5f5;
  border-radius: 8px;
}

.day-cell--selected {
  color: white;
  transition: transform 0.3s ease-in-out;
  /* background: #675ce5; */
}

.day-cell--range {
  /* background: #dcd9ff; */
  background: #e4f3fa;
}

.day-cell:not(.day-cell--faded) {
  cursor: pointer;
}

.month {
  /* padding: 0 43px; */
  padding: 0 24px;
}

.day-container {
  /* padding: 0 39px; */
  padding: 0 18px;
  margin-bottom: 10px;
}

.day-cell-range-start {
  border-radius: 8px 0px 0px 8px;
  background: #006fe8;
}

.day-cell-range-end {
  border-radius: 0px 8px 8px 0px;
  background: #006fe8;
}

.month {
  color: #000;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  text-align: left;
  line-height: 120%; /* 19.2px */
}

.modal-dates-title {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-dates-title .content {
  position: fixed;
  width: 100%;
  height: 100px;
}
.modal-dates-title .content div {
  padding-top: 75px;
}
.dialog-close-btn {
  position: absolute;
  top: 28px;
  right: 16px;
  cursor: pointer;
}
.btn-submit-dates {
  background: #2f6de0 !important;
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 19.2px */
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  display: flex;
  gap: 8px;
  border-radius: 8px;
  flex: 1 0 0;
  align-self: stretch;
  height: 40px;
  margin-top: 15px;
}

.calendar-desktop {
  background: white;
  width: 720px;
  overflow: hidden;
  /* height: auto; */
  /* top: 155px; */
  height: 440px;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  padding: 20px 1rem;
  border-radius: 8px;
  box-shadow: 0px 4px 5px -1px rgba(0, 0, 0, 0.08);
}
.calendar-desktop-header {
  color: #081316;
  text-align: left;
  font-family: Inter, sans-serif;
    position: absolute;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  margin-top: 4px;
  width: 688px;
  margin-bottom: 16px;
  line-height: 136%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* position: relative; */
}
.calendar-navigation {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 45px;
  z-index: 9999;
  left: 0;
  right: 0;
  padding: 0;
  /* padding: 0 17px 0 9px; */
}
.calendar-desktop-body {
  height: 340px;
  margin-top: 48px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  transition: transform 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
  position: relative;
  z-index: -1;
  /* position: relative;
    top: -48px; */
}
.calendar-desktop-footer {
  width: 100%;
  position: absolute;
  bottom: -380px;
}
.calendar-desktop-footer button {
  width: 390px;
  height: 40px;
  margin: auto;
}
.calendar-desktop-footer button:disabled {
  opacity: 0.5;
}

.quoter-dates-container {
  height: 70px;
  background: white;
  padding: 0 1rem;
}
.quoter-dates-container .quoter-dates-block:first-child {
  border-right: 1px solid var(--neutrals-gray-30, #bec2c5);
}
.quoter-dates-container .quoter-dates-block:last-child {
  padding-left: 16px;
}

.dates-input {
  height: 100%;
}

.dates-input-value {
  padding-top: 4px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 187%;
}
.dates-input-value.filled {
  color: var(--text-gray, #526166);
  font-family: Inter, sans-serif;
  font-size: 12px;
  text-align: left;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 14.4px */
  letter-spacing: 0.38px;
}
.dates-input-value.filled.landscape {
  font-size: 14px;
  padding-top: 8px;
}
.dates-label {
  text-align: left;
  padding-top: 6px;
  text-transform: uppercase;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #526166;
}
.quoter-dates-block {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
}
.dates-input-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}

#paxs-container {
  /* width: 342px; */
  /* width: 328px; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
}

#paxs-container > div:first-of-type:not(.pax-block) {
  width: 100%;
}

.pax-label {
  position: absolute;
  top: 0;
  padding: 3px 0 0 0 !important;
}
.pax-block {
  position: relative;
  padding: 0 1rem;
  background: white;
  /* width: 100%; */
  height: 70px !important;
  border-radius: 8px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 2px solid white;
}

.paxs-input-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  width: 258px;
  margin-top: 5px;
}
.pax-input {
  width: 137px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pax-counter {
  width: 58px;
  text-align: center;
}
.pax-btn {
  display: flex;
  width: 40px;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 9px;
  background: #eff1f4;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1),
    1px -2px 4px 0px rgba(0, 0, 0, 0.1) inset;
  color: #414e58;
  text-align: center;
  font-family: Inter, sans-serif;
   font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 110% */
}
.label {
  padding-top: 6px;
  color: rgba(0, 0, 0, 0.6);
  text-align: left;
  padding-left: 10px;
  /* width: 100%; */
  text-transform: uppercase;
  font-size: 12px;
  font-family: 'Inter', sans-serif;
  line-height: 14.4px;
  color: #526166;
}
.label span {
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  line-height: 14.4px;
  text-transform: lowercase;
  font-style: italic;
}
.label span.pax-limit-msg {
  padding-left: 6px;
}

.toggle-paxs {
  background: #7bd0c2 !important;
}


.testing {
  background: cyan!important;
  padding: 2rem;
}

.dialog-notification-button {
  padding: 0px 16px;
  display: block;
  border-radius: 8px;
  border: 2px solid #006FE8;
  /* Button */
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.12);
  width: 122px;
  height: 40px;
  margin: auto;
  margin-top: 16px;
  margin-bottom: 42px;
}
.dialog-notification-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  justify-content: center;
}
.dialog-notification-content {
  padding-top: 24px;
}`, "",{"version":3,"sources":["webpack://./node_modules/quoter365/dist/index.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;;;CAGC;;AAED;;;EAGE,sBAAsB;EACtB,MAAM;EACN,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;CAOC;;AAED;EACE,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EACN,gBAAgB;EAChB,MAAM;EACN,cAAc;KACX,WAAW;EACd,MAAM;EACN,8BAA8B;EAC9B,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,+BAA+B;EAC/B,MAAM;AACR;;AAEA;;;CAGC;;AAED;EACE,SAAS;EACT,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;EACE,SAAS;EACT,MAAM;EACN,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,yCAAyC;UACjC,iCAAiC;AAC3C;;AAEA;;CAEC;;AAED;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;CAEC;;AAED;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,mBAAmB;AACrB;;AAEA;;;CAGC;;AAED;;;;EAIE,+GAA+G;EAC/G,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,cAAc;AAChB;;AAEA;;CAEC;;AAED;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;EACN,yBAAyB;EACzB,MAAM;AACR;;AAEA;;;;CAIC;;AAED;;;;;EAKE,oBAAoB;EACpB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EACN,gCAAgC;EAChC,MAAM;EACN,eAAe;EACf,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,cAAc;EACd,MAAM;EACN,SAAS;EACT,MAAM;EACN,UAAU;EACV,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,oBAAoB;AACtB;;AAEA;;;CAGC;;AAED;;;;EAIE,0BAA0B;EAC1B,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,YAAY;AACd;;AAEA;;;CAGC;;AAED;EACE,6BAA6B;EAC7B,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;;AAED;EACE,0BAA0B;EAC1B,MAAM;EACN,aAAa;EACb,MAAM;AACR;;AAEA;;CAEC;;AAED;EACE,kBAAkB;AACpB;;AAEA;;CAEC;;AAED;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AAED;EACE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;EAEE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;AACjB;;AAEA;;CAEC;;AAED;EACE,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;;;;;;;;EAQE,cAAc;EACd,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;;AAED;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA,wEAAwE;;AAExE;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,+EAA+E;EAC/E,mGAAmG;EACnG,uGAAuG;AACzG;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;AACA;uBACuB;AACvB,mBAAmB;;AAEnB,yGAAyG;AACzG,kGAAkG;;AAElG;;;;;;;;;;;GAWG;;AAEH;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA,6BAA6B,oCAAoC,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,iBAAiB;EAC7H,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;;AAEjB,oCAAoC;;AAEpC,sBAAsB;;AAEtB,iBAAiB;AACjB;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;KACG;EACH,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;aACW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,sBAAsB;AACxB;AACA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB;6CAC2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AACA;;;GAGG;;AAEH;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd;iBACe;EACf,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;IAC5B,kBAAkB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,OAAO;EACP,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,8DAA8D;EAC9D,kBAAkB;EAClB,WAAW;EACX;iBACe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB;6CAC2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,8BAA8B;GAC7B,eAAe;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["/*\n! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com\n*/\n\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box;\n  /* 1 */\n  border-width: 0;\n  /* 2 */\n  border-style: solid;\n  /* 2 */\n  border-color: #e5e7eb;\n  /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n*/\n\nhtml {\n  line-height: 1.5;\n  /* 1 */\n  -webkit-text-size-adjust: 100%;\n  /* 2 */\n  -moz-tab-size: 4;\n  /* 3 */\n  -o-tab-size: 4;\n     tab-size: 4;\n  /* 3 */\n  font-family: Inter, sans-serif;\n  /* 4 */\n  font-feature-settings: normal;\n  /* 5 */\n  font-variation-settings: normal;\n  /* 6 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0;\n  /* 1 */\n  line-height: inherit;\n  /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0;\n  /* 1 */\n  color: inherit;\n  /* 2 */\n  border-top-width: 1px;\n  /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font family by default.\n2. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  /* 1 */\n  font-size: 1em;\n  /* 2 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0;\n  /* 1 */\n  border-color: inherit;\n  /* 2 */\n  border-collapse: collapse;\n  /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  /* 1 */\n  font-feature-settings: inherit;\n  /* 1 */\n  font-variation-settings: inherit;\n  /* 1 */\n  font-size: 100%;\n  /* 1 */\n  font-weight: inherit;\n  /* 1 */\n  line-height: inherit;\n  /* 1 */\n  color: inherit;\n  /* 1 */\n  margin: 0;\n  /* 2 */\n  padding: 0;\n  /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button;\n  /* 1 */\n  background-color: transparent;\n  /* 2 */\n  background-image: none;\n  /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield;\n  /* 1 */\n  outline-offset: -2px;\n  /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  /* 1 */\n  font: inherit;\n  /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\n\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::-moz-placeholder, textarea::-moz-placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  /* 1 */\n  color: #9ca3af;\n  /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  /* 1 */\n  vertical-align: middle;\n  /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n\n[hidden] {\n  display: none;\n}\n\n*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}\n\n.quoter-absolute {\n  position: absolute;\n}\n\n.quoter-relative {\n  position: relative;\n}\n\n.quoter-left-\\[-26px\\] {\n  left: -26px;\n}\n\n.quoter-left-\\[-40px\\] {\n  left: -40px;\n}\n\n.quoter-left-\\[16px\\] {\n  left: 16px;\n}\n\n.quoter-left-\\[46px\\] {\n  left: 46px;\n}\n\n.quoter-top-4 {\n  top: 1rem;\n}\n\n.quoter-top-\\[75px\\] {\n  top: 75px;\n}\n\n.quoter-mb-5 {\n  margin-bottom: 1.25rem;\n}\n\n.quoter-mb-64 {\n  margin-bottom: 16rem;\n}\n\n.quoter-mb-7 {\n  margin-bottom: 1.75rem;\n}\n\n.quoter-mb-\\[10px\\] {\n  margin-bottom: 10px;\n}\n\n.quoter-ml-0 {\n  margin-left: 0px;\n}\n\n.quoter-ml-4 {\n  margin-left: 1rem;\n}\n\n.quoter-ml-\\[10px\\] {\n  margin-left: 10px;\n}\n\n.quoter-ml-\\[32px\\] {\n  margin-left: 32px;\n}\n\n.quoter-mt-1 {\n  margin-top: 0.25rem;\n}\n\n.quoter-mt-2 {\n  margin-top: 0.5rem;\n}\n\n.quoter-mt-3 {\n  margin-top: 0.75rem;\n}\n\n.quoter-mt-\\[-3px\\] {\n  margin-top: -3px;\n}\n\n.quoter-mt-\\[10px\\] {\n  margin-top: 10px;\n}\n\n.quoter-mt-\\[1px\\] {\n  margin-top: 1px;\n}\n\n.quoter-mt-\\[4px\\] {\n  margin-top: 4px;\n}\n\n.quoter-mt-\\[8px\\] {\n  margin-top: 8px;\n}\n\n.quoter-flex {\n  display: flex;\n}\n\n.quoter-h-\\[48px\\] {\n  height: 48px;\n}\n\n.quoter-h-\\[60px\\] {\n  height: 60px;\n}\n\n.quoter-h-\\[70px\\] {\n  height: 70px;\n}\n\n.quoter-w-\\[145px\\] {\n  width: 145px;\n}\n\n.quoter-w-\\[163px\\] {\n  width: 163px;\n}\n\n.quoter-w-\\[228px\\] {\n  width: 228px;\n}\n\n.quoter-w-\\[252px\\] {\n  width: 252px;\n}\n\n.quoter-w-\\[270px\\] {\n  width: 270px;\n}\n\n.quoter-w-\\[328px\\] {\n  width: 328px;\n}\n\n.quoter-w-\\[416px\\] {\n  width: 416px;\n}\n\n.quoter-w-full {\n  width: 100%;\n}\n\n.quoter-w-\\[380px\\] {\n  width: 380px;\n}\n\n.quoter-w-\\[136px\\] {\n  width: 136px;\n}\n\n.quoter-w-\\[258px\\] {\n  width: 258px;\n}\n\n.quoter-max-w-\\[328px\\] {\n  max-width: 328px;\n}\n\n.quoter-cursor-pointer {\n  cursor: pointer;\n}\n\n.quoter-flex-row {\n  flex-direction: row;\n}\n\n.quoter-flex-col {\n  flex-direction: column;\n}\n\n.quoter-items-center {\n  align-items: center;\n}\n\n.quoter-rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.quoter-rounded-md {\n  border-radius: 0.375rem;\n}\n\n.quoter-border-white {\n  --tw-border-opacity: 1;\n  border-color: rgb(255 255 255 / var(--tw-border-opacity));\n}\n\n.quoter-bg-blue-quoter {\n  --tw-bg-opacity: 1;\n  background-color: rgb(1 95 199 / var(--tw-bg-opacity));\n}\n\n.quoter-p-0 {\n  padding: 0px;\n}\n\n.quoter-p-\\[10px\\] {\n  padding: 10px;\n}\n\n.quoter-pr-4 {\n  padding-right: 1rem;\n}\n\n.quoter-pt-1 {\n  padding-top: 0.25rem;\n}\n\n.quoter-text-left {\n  text-align: left;\n}\n\n.quoter-font-sans {\n  font-family: Inter, sans-serif;\n}\n\n.quoter-text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.quoter-text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.quoter-text-\\[14px\\] {\n  font-size: 14px;\n}\n\n.quoter-text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.quoter-font-bold {\n  font-weight: 700;\n}\n\n.quoter-font-normal {\n  font-weight: 400;\n}\n\n.quoter-font-semibold {\n  font-weight: 600;\n}\n\n.quoter-capitalize {\n  text-transform: capitalize;\n}\n\n.quoter-italic {\n  font-style: italic;\n}\n\n.quoter-text-error {\n  --tw-text-opacity: 1;\n  color: rgb(214 92 94 / var(--tw-text-opacity));\n}\n\n.quoter-text-grey-primary {\n  --tw-text-opacity: 1;\n  color: rgb(82 97 102 / var(--tw-text-opacity));\n}\n\n.quoter-shadow-lg {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n@media (min-width: 640px) {\n  .sm\\:quoter-mr-\\[10px\\] {\n    margin-right: 10px;\n  }\n\n  .sm\\:quoter-mt-0 {\n    margin-top: 0px;\n  }\n\n  .sm\\:quoter-flex {\n    display: flex;\n  }\n\n  .sm\\:quoter-w-\\[228px\\] {\n    width: 228px;\n  }\n\n  .sm\\:quoter-w-\\[330px\\] {\n    width: 330px;\n  }\n\n  .sm\\:quoter-max-w-\\[570px\\] {\n    max-width: 570px;\n  }\n\n  .sm\\:quoter-flex-row {\n    flex-direction: row;\n  }\n\n  .sm\\:quoter-items-start {\n    align-items: flex-start;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:quoter-absolute {\n    position: absolute;\n  }\n\n  .md\\:quoter-relative {\n    position: relative;\n  }\n\n  .md\\:quoter-top-\\[90px\\] {\n    top: 90px;\n  }\n\n  .md\\:quoter-w-\\[344px\\] {\n    width: 344px;\n  }\n\n  .md\\:quoter-max-w-\\[344px\\] {\n    max-width: 344px;\n  }\n\n  .md\\:quoter-text-center {\n    text-align: center;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:quoter-fixed {\n    position: fixed;\n  }\n\n  .lg\\:quoter-absolute {\n    position: absolute;\n  }\n\n  .lg\\:quoter-top-\\[280px\\] {\n    top: 280px;\n  }\n\n  .lg\\:quoter-top-\\[464px\\] {\n    top: 464px;\n  }\n\n  .lg\\:quoter-top-\\[90px\\] {\n    top: 90px;\n  }\n}\n/* @tailwind base;\n@tailwind components; */\n@tailwind utilities;\n\n/* @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap'); */\n/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'); */\n\n/* html,body {\n  background: #0463C7!important;\n  margin: 2rem auto;\n}\n\n.App {\n  width: 328px;\n  display: flex!important;\n  margin: auto!important;\n  align-items: center!important;\n  justify-content: center!important;\n} */\n\n.quoter-bg-overlay {\n  background: #000;\n  opacity: 0;\n  position: absolute;\n  z-index: 98;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.quoter-bg-overlay.fade-in { /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */\n  animation: fadein 1s;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n}\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 0.35;\n  }\n}\n\n/* Firefox < 16 */\n\n/* Safari, Chrome and Opera > 12.1 */\n\n/* Internet Explorer */\n\n/* Opera < 12.1 */\n.main-quoter-container {\n  /* max-width: 342px; */\n  width: 328px;\n  position: relative;\n  z-index: 100;\n}\n.main-quoter-container.normal-mode {\n  /* background: \n  ; */\n  width: 100%;\n}\n.main-quoter-container.compact-mode {\n  /* background: lime; */\n  width: 328px;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n*/ .MuiBox-root {\n  color: #526166;\n  font-weight: 600;\n}\n\n.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {\n  padding-top: 25px;\n  padding-bottom: 13px;\n}\n\n#quoter-destination\n  svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiSelect-icon.MuiSelect-iconOutlined {\n  top: 23px;\n  right: 16px;\n}\n\n.MuiMenu-paper {\n  transition-duration: 0s !important;\n}\n\n#quoter-destination .MuiInputBase-root.MuiOutlinedInput-root {\n  border-radius: 8px;\n}\n\n.quoter-dates-container,\n.quoter-pax-ages {\n  border-radius: 8px;\n  border: 1px solid #bec2c5;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.quoter-dates-block,\n.quoter-block {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.quoter-dates-block .date {\n  font-family: Inter, sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 14px; /* 14.4px */\n  letter-spacing: 0.48px;\n}\n.quoter-dates-from-date,\n.quoter-dates-to-date,\n.quoter-block {\n  padding-left: 14px;\n}\n\n.quoter-dates-from-date {\n  border-right: 1px solid #bec2c5;\n}\n\n.quoter-dates-to-date {\n}\n\n#quoter-dates {\n}\n\n#quoter-dates .label {\n  margin-top: -2px;\n}\n#quoter-dates .data-dates .label {\n  margin-top: -2px;\n}\n#quoter-dates .data-dates .date {\n  margin-top: 2px;\n}\n\n.quoter-pax-ages button {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: #eff1f4;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1),\n    1px -2px 4px 0px rgba(0, 0, 0, 0.1) inset;\n  color: #414e58;\n  text-align: center;\n  font-family: Inter, sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 110% */\n}\n.ages-selection-container {\n  display: flex;\n}\n\n.submit-btn {\n  border-radius: 8px;\n  background: var(--secondary-50-main, #7bd0c2);\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.12);\n}\n\n#quoter-dates,\n.quoter-block {\n  background: white;\n}\n\n.MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {\n  background: white;\n}\n\n.MuiInput-input {\n  font-size: 45px;\n}\n\nli.MuiButtonBase-root.MuiMenuItem-root.MuiMenuItem-gutters.MuiMenuItem-root.MuiMenuItem-gutters.text-grey-primary.css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root {\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n}\n/* .MuiTooltip-popper {\n  margin-bottom: 0;\n  transform: translate3d(262.667px, -468.667px, 0px)!important;\n} */\n\nlabel {\n  font-family: Inter, sans-serif;\n}\n\n.border-error-field {\n  border: 2px solid #d65c5e !important;\n}\n\n#quoter-destination fieldset {\n  border-color: white;\n}\n\n.quote-submit-btn {\n  font-family: 'Inter', sans-serif;\n  width: 100%;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quote-submit-btn:disabled {\n  opacity: 0.2;\n}\n#quoter-destination .MuiInputBase-root.MuiOutlinedInput-root {\n  border-radius: 8px;\n}\n.dest_label {\n  position: absolute;\n  font-family: Inter, sans-serif;\n  top: 4px;\n  text-align: left;\n  width: auto;\n  color: #526166;\n  /* left: 48px; */\n  display: block;\n  font-size: 12px;\n  z-index: 10;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.tooltip-container {\n  position: relative;\n  width: 100%;\n}\n\n.MuiTooltip-popper[data-popper-placement*='top'] .MuiTooltip-tooltip {\n  margin-bottom: 10px !important;\n}\n\n.destination-container {\n  position: relative;\n  /* width: 328px; */\n  border-radius: 8px;\n  border: 2px solid white;\n  background: white;\n}\n\n.select_destiny .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input {\n  padding-top: 22px !important;\n}\n\n.calendar {\n  margin-top: 4px;\n  /* scroll-margin: 16px; */\n  scroll-margin-top: 104px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  border-radius: 6px 6px 0 0;\n  background-color: #1abc9c;\n  color: #fff;\n}\n\n.nav {\n  width: 30px;\n  height: 30px;\n  border: 1px solid #fff;\n  border-radius: 99px;\n  outline: 0;\n  background-color: transparent;\n  color: #fff;\n  cursor: pointer;\n}\n\n.week-container,\n.day-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.week-container {\n  width: 100%;\n  padding: 0 39px;\n  display: flex;\n}\n\n.week-cell,\n.day-cell {\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-text-select: none;\n  -webkit-user-select: none;\n  flex: 0 0 calc(100% / 7);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.875rem;\n  border: 0;\n  background-color: transparent;\n  color: #002430;\n  /* width: 32px;\n  height: 32px; */\n  /* margin-bottom: 0.75rem; */\n  width: 40px;\n  height: 40px;\n  margin-bottom: 7px;\n}\n\n.week-cell {\n  text-align: center;\n  font-family: Inter, sans-serif;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 12px;\n  line-height: 120%;\n  text-transform: uppercase;\n  color: #95a2a6;\n  padding: 0.55rem 0;\n  /* padding: 0.55rem; */\n}\n\n.day-cell--faded,\n.day-cell--disabled {\n  pointer-events: none;\n  color: #b2b2b9;\n}\n\n.day-cell--today {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n}\n\n.day-cell--selected {\n  color: white;\n  transition: transform 0.3s ease-in-out;\n  /* background: #675ce5; */\n}\n\n.day-cell--range {\n  /* background: #dcd9ff; */\n  background: #e4f3fa;\n}\n\n.day-cell:not(.day-cell--faded) {\n  cursor: pointer;\n}\n\n.month {\n  /* padding: 0 43px; */\n  padding: 0 24px;\n}\n\n.day-container {\n  /* padding: 0 39px; */\n  padding: 0 18px;\n  margin-bottom: 10px;\n}\n\n.day-cell-range-start {\n  border-radius: 8px 0px 0px 8px;\n  background: #006fe8;\n}\n\n.day-cell-range-end {\n  border-radius: 0px 8px 8px 0px;\n  background: #006fe8;\n}\n\n.month {\n  color: #000;\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  text-align: left;\n  line-height: 120%; /* 19.2px */\n}\n\n.modal-dates-title {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.modal-dates-title .content {\n  position: fixed;\n  width: 100%;\n  height: 100px;\n}\n.modal-dates-title .content div {\n  padding-top: 75px;\n}\n.dialog-close-btn {\n  position: absolute;\n  top: 28px;\n  right: 16px;\n  cursor: pointer;\n}\n.btn-submit-dates {\n  background: #2f6de0 !important;\n  color: #fff;\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 120%; /* 19.2px */\n  padding: 0px 16px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  border-radius: 8px;\n  flex: 1 0 0;\n  align-self: stretch;\n  height: 40px;\n  margin-top: 15px;\n}\n\n.calendar-desktop {\n  background: white;\n  width: 720px;\n  overflow: hidden;\n  /* height: auto; */\n  /* top: 155px; */\n  height: 440px;\n  display: flex;\n  flex-direction: column;\n  z-index: 9999;\n  padding: 20px 1rem;\n  border-radius: 8px;\n  box-shadow: 0px 4px 5px -1px rgba(0, 0, 0, 0.08);\n}\n.calendar-desktop-header {\n  color: #081316;\n  text-align: left;\n  font-family: Inter, sans-serif;\n    position: absolute;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  margin-top: 4px;\n  width: 688px;\n  margin-bottom: 16px;\n  line-height: 136%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  /* position: relative; */\n}\n.calendar-navigation {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  top: 45px;\n  z-index: 9999;\n  left: 0;\n  right: 0;\n  padding: 0;\n  /* padding: 0 17px 0 9px; */\n}\n.calendar-desktop-body {\n  height: 340px;\n  margin-top: 48px;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  transition: transform 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);\n  position: relative;\n  z-index: -1;\n  /* position: relative;\n    top: -48px; */\n}\n.calendar-desktop-footer {\n  width: 100%;\n  position: absolute;\n  bottom: -380px;\n}\n.calendar-desktop-footer button {\n  width: 390px;\n  height: 40px;\n  margin: auto;\n}\n.calendar-desktop-footer button:disabled {\n  opacity: 0.5;\n}\n\n.quoter-dates-container {\n  height: 70px;\n  background: white;\n  padding: 0 1rem;\n}\n.quoter-dates-container .quoter-dates-block:first-child {\n  border-right: 1px solid var(--neutrals-gray-30, #bec2c5);\n}\n.quoter-dates-container .quoter-dates-block:last-child {\n  padding-left: 16px;\n}\n\n.dates-input {\n  height: 100%;\n}\n\n.dates-input-value {\n  padding-top: 4px;\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 187%;\n}\n.dates-input-value.filled {\n  color: var(--text-gray, #526166);\n  font-family: Inter, sans-serif;\n  font-size: 12px;\n  text-align: left;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 120%; /* 14.4px */\n  letter-spacing: 0.38px;\n}\n.dates-input-value.filled.landscape {\n  font-size: 14px;\n  padding-top: 8px;\n}\n.dates-label {\n  text-align: left;\n  padding-top: 6px;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  color: #526166;\n}\n.quoter-dates-block {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  cursor: pointer;\n}\n.dates-input-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n#paxs-container {\n  /* width: 342px; */\n  /* width: 328px; */\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 8px;\n}\n\n#paxs-container > div:first-of-type:not(.pax-block) {\n  width: 100%;\n}\n\n.pax-label {\n  position: absolute;\n  top: 0;\n  padding: 3px 0 0 0 !important;\n}\n.pax-block {\n  position: relative;\n  padding: 0 1rem;\n  background: white;\n  /* width: 100%; */\n  height: 70px !important;\n  border-radius: 8px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border: 2px solid white;\n}\n\n.paxs-input-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 258px;\n  margin-top: 5px;\n}\n.pax-input {\n  width: 137px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.pax-counter {\n  width: 58px;\n  text-align: center;\n}\n.pax-btn {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: #eff1f4;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1),\n    1px -2px 4px 0px rgba(0, 0, 0, 0.1) inset;\n  color: #414e58;\n  text-align: center;\n  font-family: Inter, sans-serif;\n   font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px; /* 110% */\n}\n.label {\n  padding-top: 6px;\n  color: rgba(0, 0, 0, 0.6);\n  text-align: left;\n  padding-left: 10px;\n  /* width: 100%; */\n  text-transform: uppercase;\n  font-size: 12px;\n  font-family: 'Inter', sans-serif;\n  line-height: 14.4px;\n  color: #526166;\n}\n.label span {\n  font-weight: 400;\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  line-height: 14.4px;\n  text-transform: lowercase;\n  font-style: italic;\n}\n.label span.pax-limit-msg {\n  padding-left: 6px;\n}\n\n.toggle-paxs {\n  background: #7bd0c2 !important;\n}\n\n\n.testing {\n  background: cyan!important;\n  padding: 2rem;\n}\n\n.dialog-notification-button {\n  padding: 0px 16px;\n  display: block;\n  border-radius: 8px;\n  border: 2px solid #006FE8;\n  /* Button */\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.12);\n  width: 122px;\n  height: 40px;\n  margin: auto;\n  margin-top: 16px;\n  margin-bottom: 42px;\n}\n.dialog-notification-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 32px;\n  justify-content: center;\n}\n.dialog-notification-content {\n  padding-top: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
